import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppUpdateService } from './services/app-update.service';

@Component({
    selector: 'app-root',
    imports: [RouterModule],
    template: '<router-outlet></router-outlet>',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    constructor(private readonly _appUpdateService: AppUpdateService) {}
}
